module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "baseline-list"
  }, _vm._l((_vm.baselines), function(baseline) {
    return _c('div', [_c('a', {
      class: {
        active: _vm.isCurrentBaseline(baseline)
      },
      attrs: {
        "title": baseline.name
      },
      on: {
        "click": function($event) {
          _vm.pushTheState(baseline)
        }
      }
    }, [_vm._v(_vm._s(baseline.name))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb681e92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaselineList.vue
// module id = 1029
// module chunks = 1